module.exports = __webpack_public_path__ + "static/media/two-coins.a4aec4a9.svg";